import { Permission } from '_metronic/helpers'
import { useAuth } from 'app/modules/auth'

/**
 * Grupos com `Usuario:create` no `permission.json` do backend. O front só conhece o nome do grupo
 * (`currentUser.grupo.nome`), não os perfis — mesma limitação de `_unidadePermissao.ts`; o backend
 * segue como autoridade e devolve 403.
 */
export const GRUPO_GESTOR_ACESSO = 'GESTOR_ACESSO'

export const GRUPOS_USUARIO_CREATE: string[] = [Permission.SuperAdmin, GRUPO_GESTOR_ACESSO]

export const podeCriarUsuario = (nomeGrupo?: string): boolean =>
  !!nomeGrupo && GRUPOS_USUARIO_CREATE.includes(nomeGrupo)

export const usePermissaoUsuarioCreate = (): boolean => {
  const { currentUser } = useAuth()
  return podeCriarUsuario(currentUser?.grupo?.nome)
}
